/*
 *
 * RefoundBackbookISP
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 11-Mar-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import RefoundBackbookISP from './RefoundBackbookISP'
import { nullSafe } from 'Utility/globalMethods'
import * as TriggerTimelineActions from 'Store/actions/triggerTimeline'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(TriggerTimelineActions, dispatch)
})

const mapStateToProps = (state) => ({
  userType: nullSafe(() => state.triggerTimeline.current.additionalInfo.userType, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(RefoundBackbookISP)
